export const appName = "Notate";